// extracted by css-extract-rspack-plugin
export default {"delivery":"Delivery_delivery__KZPP1"};